import React, { useState } from "react"
import { PaymentService } from "../../services/PaymentService"
import AntTable from "../../components/table/Table"
import { Flex } from "antd"
import { ColumnsType } from "antd/es/table"
import { MemberService } from "../../services/MemberService"

interface Props {
    user: {
        id: number
    }
}

const MemberPaymentTransaction = (props: Props) => {

    const [refreshData, setRefreshData] = useState<boolean>(false)

    const [columns] = useState<ColumnsType<any>>([
        {
            title: 'Transaction ID',
            align: 'center',
            dataIndex: 'transaction_id',
            key: 'transaction_id'
        },
        {
            title: 'Send Amount',
            align: 'center',
            dataIndex: 'send_amount',
            key: 'send_amount',
            render: (value, record) => {
                return `${value} ${record?.send_currency}`
            }
        },
        {
            title: 'Receive Amount',
            align: 'center',
            dataIndex: 'receive_amount',
            key: 'receive_amount',
            render: (value, record) => {
                return `${value} ${record?.receive_currency}`
            }
        },
        {
            title: 'Fee',
            align: 'center',
            dataIndex: 'fee',
            key: 'fee'
        },
        {
            title: 'Status',
            align: 'center',
            dataIndex: 'transaction_status',
            key: 'transaction_status'
        },

        
        // {
        //     title: 'Actions',
        //     align: 'center',
        //     dataIndex: 'actions',
        //     key: 'created_at',
        //     render: (text, record: any) => {
        //         return (
        //             <Flex gap="small" justify="center" wrap="wrap">
        //                 <span></span>
        //             </Flex>
        //         )
        //     }
        // },
    ])

    React.useEffect(() => {
        setRefreshData(p => !p)
    }, [props.user?.id])

    const onLoadData = async (params: any = {}) => {
        const payload = {
            ...params,
            user_id: props.user?.id,
        }
        const res = await MemberService.getMemberPaymentTransactions(payload)
        return res
    }

    return (
        <AntTable
            refresh={refreshData}
            defaultColumns={false}
            menuOptions={false}
            search={false}
            title="Transaction"
            columns={columns}
            onLoadData={onLoadData}
        />
    )

}

export default MemberPaymentTransaction